export default {
      id: "common__fuel_tanker-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__fuel_tanker",
      toString: function () {
        return this.url;
      }
    }